import { render, staticRenderFns } from "./PageTransition.vue?vue&type=template&id=349c642c&scoped=true"
import script from "./PageTransition.vue?vue&type=script&lang=js"
export * from "./PageTransition.vue?vue&type=script&lang=js"
import style0 from "./PageTransition.vue?vue&type=style&index=0&id=349c642c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c642c",
  null
  
)

export default component.exports